module.exports = __webpack_public_path__ + "static/media/per-row-icon.2779f36f.svg";